import React, { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import RecordItem from './RecordItem';

import { FieldTableType } from 'src/components/common/table/TypeCustom';
import { getField } from 'src/common/helper';

const border1 = '1px solid #0000001f'
const border3 = '3px solid #0000001f'

type TableQuotationProps = {
  items: any[];
  fields: FieldTableType[];
};

const TableQuotation: React.FC<TableQuotationProps> = (props) => {
  const [discounts, setDiscounts] = useState<any[]>([false, false]);

  const checkRowBold = (indexCurrent: number) => {
    if (props.items[props.items.length - 1] && props.items[props.items.length - 1].treatment) {
      const numberRow = props.items[props.items.length - 1].treatment === '割引後合計' ? 3 : 1;

      for (let index = 1; index <= numberRow; index++) {
        if (indexCurrent === props.items.length - index) {
          return true;
        }
      }
    }

    return false;
  };

  useEffect(() => {
    const getDiscounts = () => {
      let apply_discount = false;
      let roundup = false;

      for (let i = 0; i < props.items.length; i++) {
        if (getField(props.items[i], 'treatment').includes('*')) {
          apply_discount = true;
        } 
        if (getField(props.items[i], 'treatment').includes('^')) {
          roundup = true;
        }
      };

      setDiscounts([apply_discount, roundup]);
    }

    getDiscounts();
  }, [props.items]);

  return (
    <TableContainer
      component={Paper}
      sx={{
        boxShadow: 'none',
        '& *': { color: 'primary.dark', fontSize: '12px' }
      }}
    >
      <Table
        stickyHeader
        sx={{
          width: '100%',
          '& .MuiTableCell-root.MuiTableCell-head': {
            borderBottom: border3,
            fontWeight: 700,
            fontSize: '12px',
            height: '12.7mm',
            p: '0 4.2333mm',
          }
        }}
        aria-label='simple table'>
        <TableHead >
          <TableRow >
            {props.fields.map((field, index: number) => (
              <TableCell key={index} align={field.align} sx={{ width: field.width, bgcolor: 'primary.light' }}>{field.label}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {props.items.map((item, index) => (
            <RecordItem 
              key={index} 
              item={item} 
              fields={props.fields}
              borderBottom={index === props.items.length - 2 ? border3 : border1}
              isTotal={checkRowBold(index)}
              discounts={discounts}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableQuotation;
